export const knowledgeBaseFoldersQueryKey = [
  'knowledge-base',
  'folders',
] as const

export function getKnowledgeBaseFoldersQueryKey(
  userId: string | null,
  activeTenantId: string | null,
) {
  return [...knowledgeBaseFoldersQueryKey, userId, activeTenantId] as const
}
